<template>
  <VContainer v-if="!isKit" class="pa-0">
    <VRow no-gutters class="cart-notification-item">
      <VCol cols="4">
        <LineItemImage
          :product="product"
          :banner="ribbonText"
        />
      </VCol>
      <VCol cols="8" class="py-4 pl-0 d-flex flex-column description">
        <VRow no-gutters>
          <VCol cols="12" class="font12">
            {{ product.productId }}
          </VCol>
          <VCol cols="12" class="font-weight-bold text-uppercase">
            {{ product.name }}
          </VCol>
        </VRow>
        <VRow
          v-if="cartStateNotification"
          no-gutters
          class="align-end mr-0"
        >
          <VCol class="pa-0" style="line-height: 1.1;">
            <span class="text-greyedOut">
              {{ quantityText }}
            </span>
            <span class="font-weight-bold">
              {{ product.quantity }}
            </span>
          </VCol>
          <VCol class="pa-0 pr-3">
            <VRow class="justify-end text-greyedOut font12">
              <span
                v-if="isSale"
                class="text-strikethrough pr-2"
              >
                {{ product.formattedOriginalPrice }}
              </span>
              <span :class="{'text-secondary': isSale}">
                {{ itemPriceText }}
              </span>
            </VRow>
            <VRow class="justify-end font-weight-medium subheader">
              {{ product.formattedSubTotal }}
            </VRow>
          </VCol>
        </VRow>
      </VCol>
      <VCol cols="12" class="pa-0">
        <VDivider v-if="product.subTotal && cartStateNotification" />
      </VCol>
    </VRow>
  </VContainer>
</template>

<script setup lang="ts">
import LineItemImage from '~/components/lineItem/LineItemImage.vue'
import type { CartProduct } from '~/types/cart'
import { ItemType } from '~/types/lineitem'
interface Props {
  quantityText?: string
  itemPriceText?: string
  ribbonText?: string
  product: CartProduct
  isSale?: boolean
  cartStateNotification?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  quantityText: '',
  itemPriceText: '',
  ribbonText: '',
  isSale: false,
  cartStateNotification: false
})

const isKit = computed(() => props.product.itemType === ItemType.KIT)
</script>

<style lang="scss" scoped>
.cart-notification-item {
  position: relative;

  .description {
    line-height: 1.1;
    min-height: 104px;
  }
}
</style>
